import { useState } from 'react'
import type { ERC20BalanceResult } from '@g4g/wallet-modal/hooks/wallet/types'
import type { ShoppingCartTotal } from '../../shopping-cart/provider/types'
import { useUpdateEffect } from 'react-use'
import type { ERC20Names } from '@g4g/wallet-modal/types'

export default function useInsufficientFundsTracker(
  balances?: ERC20BalanceResult,
  total?: ShoppingCartTotal
) {
  const [insufficientToken, setInsufficientToken] = useState<{
    prps: boolean
    dubi: boolean
    paymentOption: ERC20Names
  }>({ dubi: false, prps: false, paymentOption: 'Purpose' })

  useUpdateEffect(() => {
    if (!balances || !total) {
      return
    }

    const purposePrice = total.price.crypto.wei.Purpose
    const dubiPrice = total.price.crypto.wei.Dubi
    const totalPurpose = balances.total.wei.Purpose
    const totalDubi = balances.total.wei.Dubi

    if (!purposePrice || !dubiPrice || !totalPurpose || !totalDubi) {
      return
    }

    const notEnoughPrps = totalPurpose.lt(purposePrice)
    const notEnoughDubi = totalDubi.lt(dubiPrice)

    if (notEnoughPrps && notEnoughDubi) {
      setInsufficientToken({ dubi: true, prps: true, paymentOption: 'Purpose' })
      return
    }

    if (notEnoughPrps) {
      setInsufficientToken({ prps: true, dubi: false, paymentOption: 'Dubi' })
      return
    }

    if (notEnoughDubi) {
      setInsufficientToken({ prps: false, dubi: true, paymentOption: 'Purpose' })
      return
    }

    // Reset to initial state if enough of both
    setInsufficientToken({ prps: false, dubi: false, paymentOption: 'Purpose' })
  }, [balances, total])

  return { insufficientToken }
}
